import React from "react";
import { UserCardStyles } from "./Card.styled";
import PropTypes from "prop-types";
import MessageIcon from "../../assets/icons/Message.svg";
import { NavLink } from "react-router-dom";
import { getFormattedDate } from "../../utils/DateUtils";

function UserCard({ UsersList, title }) {
	return (
		<div>
			<UserCardStyles>
				<p className='title'>{title}</p>
				{UsersList.map((data) => {
					return (
						<div className='details' key={data?.objectId}>
							<section>
								{/* <img
                                    src={data.src}
                                    style={{ height: '', width: '' }}
                                    alt="users image"
                                /> */}

								<div>
									<p className='name'>
										{data?.firstName} {data?.lastName || data?.username}
									</p>
									<p className='email'>{data?.workEmail || data?.email || data?.username}</p>
									<p className='email'>{getFormattedDate(data?.createdAt)}</p>
								</div>
							</section>

							<section>
								<NavLink
									to={title === "Admins" ? "/users" : `/customer/${data?.objectId}/general`}
									className={({ isActive }) => (isActive ? "active " : "")}>
									<img src={MessageIcon} alt='message icon' style={{ height: "10", width: "10" }} />
								</NavLink>
							</section>
						</div>
					);
				})}
			</UserCardStyles>
		</div>
	);
}

UserCard.propTypes = {
	// title: PropTypes.string,
	UsersList: PropTypes.array,
	title: PropTypes.string,
};

export default UserCard;
